"use client";

import { useSyncExternalStore } from "react";

const MQ = "(prefers-reduced-motion: reduce)";

function subscribe(callback: () => void) {
  if (typeof window === "undefined" || !window.matchMedia) {
    return () => {};
  }
  const mq = window.matchMedia(MQ);
  mq.addEventListener("change", callback);
  return () => mq.removeEventListener("change", callback);
}

function getSnapshot(): boolean {
  if (typeof window === "undefined" || !window.matchMedia) return true;
  return window.matchMedia(MQ).matches;
}

function getServerSnapshot(): boolean {
  // Default to reduced motion on the server so SSR markup doesn't promise animation.
  return true;
}

/**
 * Returns true when the user has requested reduced motion at the OS level.
 * Backed by useSyncExternalStore for safe concurrent rendering + SSR.
 */
export function useReducedMotion(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
